import React from 'react';
import './VeiculoseciaFooter.scss';
import logo from '../../../assets/images/logo.png'
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { MdEmail, MdWhatsapp } from "react-icons/md";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";


function VeiculoseciaFooter() {
    return (
        <footer className='veiculoseciaFooter d-flex align-items-center'>
            <div className='veiculoseciaFooter__content container-fluid w-100'>
                <div className='row d-flex align-items-center justify-content-between w-100 flex-row'>
                    <div className='col-sm-2'>
                        <Link to='/' className='d-flex align-items-center logo'>
                            <img src={logo} alt='logo' />
                        </Link>
                    </div>

                    <div className='col-sm-8 d-flex justify-content-end'>
                        <div className='me-4'>
                            <h5 className='text-white'>ENDEREÇO</h5>
                            <p>BR 364 Perímetro Urbano de Jaciara,<br></br>Jaciara - MT, CEP: 78820-000</p>
                        </div>

                        <div className='d-flex flex-column align-items-start me-4'>
                            <h5 className='text-white'>CONTATO</h5>
                            <Button
                                className='veiculoseciaFooter__btn mb-1'
                                startIcon={<MdWhatsapp />}
                                onClick={() => window.open('https://api.whatsapp.com/send/?phone=5566999815612&text=Olá, estou interessado em adquirir um veículo', '_blank')}
                            >
                                (66) 99981-5612
                            </Button>
                            <Button           
                                className='veiculoseciaFooter__btn'
                                startIcon={<MdEmail />}  
                                onClick={() => window.open('mailto:contato@veiculosecia.com.br')}
                            >
                                 veiculoseciamt@hotmail.com
                            </Button>
                        </div>

                        <div className='d-flex flex-column align-items-start'>
                            <h5 className='text-white'>SIGA-NOS</h5>
                            <Button
                                className='veiculoseciaFooter__btn mb-1'
                                startIcon={<FaSquareInstagram />}
                                onClick={() => window.open('https://www.instagram.com/veiculosecia', '_blank')}
                            >
                                Instagram
                            </Button>
                            <Button
                                className='veiculoseciaFooter__btn'
                                startIcon={<FaFacebookSquare />}
                                onClick={() => window.open('https://pt-br.facebook.com/veiculosecia', '_blank')}
                            >
                                Facebook
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default VeiculoseciaFooter;
